import { render } from "./HomeView.vue?vue&type=template&id=0c5879bf&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=0c5879bf&scoped=true&lang=css"

import exportComponent from "/builds/coreslicer-git/coreslicer2/homepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5879bf"]])

export default __exports__